<div class="rating number">
  <div class="rate align-items-start justify-content-center" [ngClass]="{ 'rating-disabled': isViewMode }">
    <ng-container *ngFor="let rating of ratings?.rating; trackBy:trackById; let i = index; let first = first; let last = last;">
      <div class="d-flex flex-column item-container">
        <span *ngIf="rating.text"
          [class]="rating?.isActive === ratingIsActive.ENABLE ? rating?.activeClass + ' ' + rating?.class : rating?.class"
          (click)="!this.checkIsViewMode() ? setRating(i) : null">
          {{rating.text}}
        </span>
        <span *ngIf="rating?.url || rating?.activeUrl"
          [class]="rating?.isActive === ratingIsActive.ENABLE ? rating?.activeClass + ' ' + rating?.class : rating?.class"
          (click)="!this.checkIsViewMode() ? setRating(i) : null">
          <img [src]="rating?.isActive === ratingIsActive.ENABLE ? rating?.activeUrl : rating?.url" alt="rating" />
        </span>
        <ng-container *ngIf="rating?.name">
          <span *ngIf="first || last; else siblingContent" class="radio-container bg-transparent">
            <label class="radio p-1 align-self-center" >
              <input [checked]="getSelected(i)" [name]="questionCode" type="radio" (click)="!this.checkIsViewMode() ? setRating(i) : null" [disabled]="isViewMode" />
              <span [class]="rating?.activeClass"></span>
            </label>
          </span>
          <ng-template #siblingContent>
            <label class="radio p-1 align-self-center">
              <input [checked]="getSelected(i)" [name]="questionCode" type="radio" (click)="!this.checkIsViewMode() ? setRating(i) : null" [disabled]="isViewMode" />
              <span [class]="rating?.activeClass"></span>
            </label>
          </ng-template>
        </ng-container>
        
        
        <small *ngIf="first" class="primary-small color-grey-500">{{textLabels.start}}</small>
        <small *ngIf="last" class="primary-small color-grey-500">{{textLabels.end}}</small>
      </div>
    </ng-container>
  </div>
</div>
